import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/interfaces/user';
import { AuthManagerService } from 'src/app/services/auth-manager/auth-manager.service';
import { UserService } from 'src/app/services/user/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-choose-plan',
  templateUrl: './choose-plan.component.html',
  styleUrls: ['./choose-plan.component.scss'],
})
export class ChoosePlanComponent implements OnInit{
  public user: User;
  public pricingPlans = environment.stripePlans;
  public mainPlanContent = [];
  public petName: string;
  public appPriceCardFeatureText: string[] = [
    'Instant email alert when your pet’s chip is scanned',
    '24/7 help & support via our dedicated hotline',
    'Unlimited changes to your details',
    'Annual keeper certificate',
    'Online account access and management',
    'Secure data storage'
  ]
  public isAuthenticated: boolean;

  constructor(
    private _router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private authManager: AuthManagerService,
  ) {
    this.user = this.route.snapshot.data.user as User;
  }

  
  ngOnInit(): void {
    this.isAuthenticated = this.authManager.isAuthenticated;
    if (this.isAuthenticated) {
      this.userService.getMe().subscribe((userResponse: User) => {
        this.user = userResponse;
      });
    }
  }

  select(planId?: string): void {
    switch (planId) {
      case environment.stripePlans.identibasePlus:
        this._router.navigate(['/identibase-plus']);
        break;
      case environment.stripePlans.identiAlertMonthly:
        this._router.navigate(['/identialert']);
        break;
      case environment.stripePlans.identiAlertAnnual:
        this._router.navigate(['/identialert']);
        break;
      case environment.stripePlans.identiAlertFindCat:
        this._router.navigate(['/identifind']);
        break;
      case environment.stripePlans.identiAlertFind:
        this._router.navigate(['/identifind']);
        break;
      default:
        this._router.navigate(['/identialert']);
    }
  }
}
